module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-image"
  }, [_c('img', {
    staticClass: "ch",
    attrs: {
      "alt": "image",
      "src": "images/ch.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "bm-title"
  }, [_c('span', {
    staticClass: "r-bold"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("hank you, Mom and Dad, for raising me to be the person I am today and for traveling with me on my entrepreneurial journey. Dad, I’m forever thankful for the lessons you taught me early on in business and for giving me the opportunity to become the spartan entrepreneur I am today. The ice business has helped me see that I can pursue anything I set my mind on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to all my mentors who have guided me on this rollercoaster ride called life. It’s a crazy ride and without all of you, I don’t think I could have survived it. Thank you to my greatest mentor and inspiration, Napoleon Hill. We may not have met in this lifetime, but I know your spirit is with me. Your dedication to creating the success principles that humanity uses to further develop themselves in every aspect is a monumental accomplishment I could only hope to achieve. Your work has formed me into the person I needed to become in order to achieve any major success.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to my love, Samantha Rossin. I believe God had us meet for a reason, and I’m glad He did. You have influenced me to do things I never thought imaginable. You picked me up when I was down, and you helped me keep things together when I felt like falling apart. I will always love you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Brandon T. Adams")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you, Mom and Dad, for always being there for me. Through my teen years, I was an uncontrollable person who had no respect for either of you. I was living on my own terms, and I immersed myself in some scary situations. I wish I had understood that your concern for me came from a genuine place. For you guys to be there for me when I snapped out of the addiction world means so much to me. I wouldn’t be where I am today without you. You guys have supported Brandon and me when we were broke, and you continue to support us by being our number one fans. You both have endless love for others, and with all of your responsibilities, you remain positive. I am honored to look up to you guys as role models and am blessed to have you as parents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Samantha Rossin")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So many people were part of the making of this book and TV show. We thank you all. If you aren’t listed here, know that we are thankful for your support on our journey. The following people went above and beyond to support us.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('span', {
    staticClass: "b-bold"
  }, [_vm._v("The Success in Your City Team")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kevin Harrington")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jeff Hoffman")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shawn Vela")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mike Silvestri")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kai Honeck")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jeff Ottum")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carlos Medina")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jonathan Hickey")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("James Naleski")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to the Keller Williams real estate community, which, through their individual teams throughout the country, made a huge contribution to fund our show.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section"
  }, [_vm._v("Scottsdale, Arizona")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mandi Monaghan")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rich Barker")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Michelle Schwartz")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Scott Kiburz")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom Ross")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Andrew Zalasky")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shea Hillenbrand")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robin Orscheln")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Glenn Pahnke")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Boys and Girls Club of Metro Phoenix")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jeremy Jones of FunkFit")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Luis Galindo of FunkFit")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chris Lampkins")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chris Lo")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section"
  }, [_vm._v("Austin, Texas")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ricky and KodiKay Cain")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jackson Cain")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Cain Team")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cain Cares")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Silvia Ward-Carden")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Michael Ames")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sean Busse")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Griffin Bruehl")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marvin and Melba Fein")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dave Haney")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Riverbend Church")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Johnny Beans Coffee")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gourdough’s Donuts")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section"
  }, [_vm._v("Boston, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("David France")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Venture Café")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Colette Phillips")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thaddeus Miles")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Christopher Wolfel")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rhett Price")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom O’Keefe")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Samuel Thompson")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Roxbury Innovation Center")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Devin Cole with WorkBar")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Griffin Bruehl")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trung The Tran")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anastasia Dvoryanchikova")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Josh Knowles")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kiyoshi Hayashi")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Danny Koo")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section"
  }, [_vm._v("Denver, Colorado")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dan Gomer")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stephen and Katie Christopher")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marie Borquez")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jourdan and Kit Baldwin")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gerrad and Deirdre Brigham and Family")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joel Comm")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Erin Cell")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brad Poppie")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section"
  }, [_vm._v("Nashville, Tennessee")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Faydra Lagro")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brandon Green")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Bell Tower")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pine Street Flats")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("James Whittaker")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Noah Anderson")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tiffany Davis")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Peter and Chellanie Grunwald")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Todd Cassetty")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brice Clark with Spark Events")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section"
  }, [_vm._v("Others")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Andrew Zalasky")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Greg Rollett")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chip Sullivan")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alex Bilodeau")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cactus Jack Barringer")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 78
// module chunks = 0